import React from 'react';
import styles from '../../styles/home.module.css';

function SectionExplain() {
    return (
        <section className={styles.SectionExplain} id="about">
            <div className={styles.InExplain}>
                <div className={styles.InExpRow}>
                    <h2>Ponujamo vam sodoben način zapisovanja vaših podatkov</h2>
                    <p>Enostavna uporaba in možnost povezovanja z vašim osebnim zdravnikom</p>
                </div>
                <div className={styles.RowImage}>
                    <img className={styles.Image} src={require('../../images/frame_teza.png')} alt="App on mobile phone" />
                    <img className={styles.Image} src={require('../../images/frame_lekarne.png')} alt="App on mobile phone" />
                    <img className={styles.Image} src={require('../../images/frame_klepet.png')} alt="App on mobile phone" />
                </div>
            </div>
        </section>
    )
}
export default SectionExplain;